import { render, staticRenderFns } from "./MediaLibrarySearch.vue?vue&type=template&id=dabde63e&scoped=true&"
import script from "./MediaLibrarySearch.vue?vue&type=script&lang=js&"
export * from "./MediaLibrarySearch.vue?vue&type=script&lang=js&"
import style0 from "./MediaLibrarySearch.vue?vue&type=style&index=0&id=dabde63e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dabde63e",
  null
  
)

export default component.exports